<template>
  <el-form
    label-width="220px"
    :inline="true"
    ref="formRef"
    :model="form"
    class="demo-form-inline"
  >
    <el-form-item label="电话" required>
      <el-input v-model="form.phone" disabled clearable />
    </el-form-item>
    <el-form-item label="一键限制用户" required>
      <el-select v-model="form.ban_limit" placeholder="" clearable>
        <el-option label="限制" :value="1" />
        <el-option label="开启" :value="0" />
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { getCurrentInstance, onMounted, ref, nextTick } from "vue";

const form = ref({
  ban_limit: "",
  id: "",
  phone: ''
});
const formRef = ref(null);

const props = defineProps(["item"]);

onMounted(() => {
  nextTick(() => {
    form.value.phone = props.item.phone;
    form.value.id = props.item.id;
  });
});

const { proxy } = getCurrentInstance();


defineExpose({ form, formRef });
</script>

<style lang="less" scoped>
.demo-form-inline .el-input {
  --el-input-width: 280px;
}

.demo-form-inline .el-select {
  --el-select-width: 280px;
}
/deep/ .el-radio-group {
  width: 280px;
}
.form-title {
  text-align: left;
  padding-left: 30px;
  margin: 20px auto 10px;
  height: 44px;
  background-color: #f2f2f2;
  border-radius: 5px;
  line-height: 44px;
}
.demo-form-inline {
  display: flex;
  flex-wrap: wrap;
}
</style>
